import React from 'react';
import { withStyles } from '@material-ui/core/styles';
import {Grid, Box, Button} from '@material-ui/core';
import Stack from '@mui/material/Stack';
import Snackbar from '@mui/material/Snackbar';
import Alert from '@mui/material/Alert';
import Dialog from '@material-ui/core/Dialog';
import MuiDialogTitle from '@material-ui/core/DialogTitle';
import MuiDialogContent from '@material-ui/core/DialogContent';
import IconButton from '@material-ui/core/IconButton';
import CloseIcon from '@material-ui/icons/Close';
import Typography from '@material-ui/core/Typography';
import TextField from '@mui/material/TextField';
import axios from 'axios';
import 'font-awesome/css/font-awesome.min.css';
import {API_URL} from '../utils/EnvVars';

const styles = (theme) => ({
  root: {
    margin: 0,
    padding: theme.spacing(2),
  },
  closeButton: {
    position: 'absolute',
    right: theme.spacing(1),
    top: theme.spacing(1),
    color: theme.palette.grey[500],
  },
});


var vertical='top',horizontal='center';

const DialogTitle = withStyles(styles)((props) => {
  const { children, classes, onClose, ...other } = props;
  return (
    <MuiDialogTitle disableTypography className={classes.root} {...other}>
      <Typography variant="h6">{children}</Typography>
      {onClose ? (
        <IconButton aria-label="close" className={classes.closeButton} onClick={onClose}>
          <CloseIcon />
        </IconButton>
      ) : null}
    </MuiDialogTitle>
  );
});

const DialogContent = withStyles((theme) => ({
  root: {
    padding: theme.spacing(2),
  },
}))(MuiDialogContent);

const CustomizedDialogs = React.forwardRef((props, ref) => { 
  const [open, setOpen] = React.useState(false); 
  const [severityAlert, setSeverityAlert] = React.useState("error");
  const [showAlert, setShowAlert] = React.useState(false);
  const [alertMessage, setAlertMessage] = React.useState("");

  const [roleName, setRoleName] = React.useState("");
  const [description, setDescription] = React.useState("");
  const [privileges, setPrivileges] = React.useState("");
  
  React.useImperativeHandle(ref, () => ({
    handleClickOpen(){
      setOpen(true);
    }
  }));
  
  const handleClose = () => {
    setOpen(false);
  };

  function hideAlert(){
		setShowAlert(false);
	}

	function saveData(){
    if(!roleName){
      setSeverityAlert("error");
      setShowAlert(true);
      setAlertMessage("Enter role name");			
      return false;
    }
    if(!privileges || privileges.length<1){
      setSeverityAlert("error");
      setShowAlert(true);
      setAlertMessage("You must select a module");			
      return false;
    }

		if(roleName){ 
			let axiosHeader = {
				headers: {
          'Content-Type': 'multipart/mixed',
          'device': 'web',
          'registerId': props.userObj.registerId,
          'uid': props.userObj.loginId,
          'fullName': props.userObj.fullName,
          'token': props.userObj.token,
        }
			}; 
    
      const data = new FormData();
      data.append('roleName', roleName);
      data.append('description', description);
      data.append('privileges', privileges);
             
			axios.post(API_URL+'/crm-create-usersroles', data, axiosHeader)
			.then((response) => {
				//console.log("RESPONSE RECEIVED: ", response.data.responseTxt);
				if(response.data.responseTxt==="success"){
          setSeverityAlert("success");
          setOpen(false);
					setShowAlert(true);
					setAlertMessage("Role details has been saved.");
          window.location.reload();	
					return false;
        }else if(response.data.responseTxt==="AlreadyExistsError"){
            setSeverityAlert("error");
            setOpen(true);
            setShowAlert(true);
            setAlertMessage("Role name must be unique. It is added earlier.");
            return false;  					
				}else{
          setSeverityAlert("error");
					setShowAlert(true);
					setAlertMessage("Role details could not be saved.");			
					return false;
				}
			})
			.catch((error) => {
          setSeverityAlert("error");
					setShowAlert(true);
					setAlertMessage(""+error);			
					return false;
			})	
		}		
	}
  
  function checkAllList(chkboxid,chkid)	{
    if(props.modules){
      if(document.getElementById(chkboxid).checked==true){
        for (let i=0; i<props.modules.length; i++)
        {
          document.getElementById(chkid+i).checked=true;
        }
      }else{
        for (let i=0; i<props.modules.length; i++)
        {
          document.getElementById(chkid+i).checked=false;
        }
      }
    }

    for (let i=0; i<props.modules.length; i++){
      if(document.getElementById('read'+i).checked==true){
        document.getElementById('module'+i).checked=true;
      }else if(document.getElementById('create'+i).checked==true){
        document.getElementById('module'+i).checked=true;
        document.getElementById('read'+i).checked=true;
      }else if(document.getElementById('update'+i).checked==true){
        document.getElementById('module'+i).checked=true;
        document.getElementById('read'+i).checked=true;
      }else if(document.getElementById('delete'+i).checked==true){
        document.getElementById('module'+i).checked=true;
        document.getElementById('read'+i).checked=true;
      }else if(document.getElementById('viewall'+i).checked==true){
        document.getElementById('module'+i).checked=true;
        document.getElementById('read'+i).checked=true;
      }else if(document.getElementById('modifyall'+i).checked==true){
        document.getElementById('module'+i).checked=true;
        document.getElementById('read'+i).checked=true;
      }else if(document.getElementById('download'+i).checked==true){
        document.getElementById('module'+i).checked=true;
        document.getElementById('read'+i).checked=true;
      }else{
        document.getElementById('module'+i).checked=false;
        document.getElementById('read'+i).checked=false;
      }
    }

    selectedPrivilegesFun();

	}

  function userRole(){ 
		let totalRows = props.modules.length;
		if(document.getElementById("modules").checked==true){
			document.getElementById("readall").checked=true;
			document.getElementById("createall").checked=true;
			document.getElementById("updateall").checked=true;
			document.getElementById("deleteall").checked=true;
      document.getElementById("viewallall").checked=true;
      document.getElementById("modifyallall").checked=true;
      document.getElementById("downloadall").checked=true;
			
			for(var i=0; i<totalRows; i++){
				document.getElementById('module'+i).checked=true;
				document.getElementById('read'+i).checked=true;
				document.getElementById('create'+i).checked=true;
				document.getElementById('update'+i).checked=true;
				document.getElementById('delete'+i).checked=true;
        document.getElementById('viewall'+i).checked=true;
        document.getElementById('modifyall'+i).checked=true;
        document.getElementById('download'+i).checked=true;
			}
		}else if(document.getElementById("modules").checked==false){
			document.getElementById("readall").checked=false;
			document.getElementById("createall").checked=false;
			document.getElementById("updateall").checked=false;
			document.getElementById("deleteall").checked=false;
      document.getElementById("viewallall").checked=false;
      document.getElementById("modifyallall").checked=false;
      document.getElementById("downloadall").checked=false;
			
			for(var i=0; i<totalRows; i++){
				document.getElementById('module'+i).checked=false;
				document.getElementById('read'+i).checked=false;
				document.getElementById('create'+i).checked=false;
				document.getElementById('update'+i).checked=false;
				document.getElementById('delete'+i).checked=false;
        document.getElementById('viewall'+i).checked=false;
        document.getElementById('modifyall'+i).checked=false;
        document.getElementById('download'+i).checked=false;
			}
			
		}

    selectedPrivilegesFun();
		
	}

  function moduleUserRole(idNum){ 
		if(document.getElementById('module'+idNum).checked==true){
			document.getElementById('read'+idNum).checked=true;
			document.getElementById('create'+idNum).checked=true;
			document.getElementById('update'+idNum).checked=true;
			document.getElementById('delete'+idNum).checked=true;
      document.getElementById('viewall'+idNum).checked=true;
      document.getElementById('modifyall'+idNum).checked=true;
      document.getElementById('download'+idNum).checked=true;

		}else if(document.getElementById('module'+idNum).checked==false){
			document.getElementById('read'+idNum).checked=false;
			document.getElementById('create'+idNum).checked=false;
			document.getElementById('update'+idNum).checked=false;
			document.getElementById('delete'+idNum).checked=false;
      document.getElementById('viewall'+idNum).checked=false;
      document.getElementById('modifyall'+idNum).checked=false;
      document.getElementById('download'+idNum).checked=false;

    }
    selectedPrivilegesFun();
  }

  function privilegeOne(idNum){ 
		if(document.getElementById('read'+idNum).checked==true){
      document.getElementById('module'+idNum).checked=true;
    }else if(document.getElementById('create'+idNum).checked==true){
      document.getElementById('module'+idNum).checked=true;
      document.getElementById('read'+idNum).checked=true;
    }else if(document.getElementById('update'+idNum).checked==true){
      document.getElementById('module'+idNum).checked=true;
      document.getElementById('read'+idNum).checked=true;
    }else if(document.getElementById('delete'+idNum).checked==true){
      document.getElementById('module'+idNum).checked=true;
      document.getElementById('read'+idNum).checked=true;
    }else if(document.getElementById('viewall'+idNum).checked==true){
      document.getElementById('module'+idNum).checked=true;
      document.getElementById('read'+idNum).checked=true;
    }else if(document.getElementById('modifyall'+idNum).checked==true){
      document.getElementById('module'+idNum).checked=true;
      document.getElementById('read'+idNum).checked=true;
    }else if(document.getElementById('download'+idNum).checked==true){
      document.getElementById('module'+idNum).checked=true;
      document.getElementById('read'+idNum).checked=true;
    }else{
      document.getElementById('module'+idNum).checked=false;
      document.getElementById('read'+idNum).checked=false;
    }
    selectedPrivilegesFun();
  }

  function selectedPrivilegesFun(){
    let selectedModuleArr = [];
    let moduleObj = {};
    let privileges = "";
    let totalRows = props.modules.length;
    for(let i=0; i<totalRows; i++){
      if(document.getElementById('module'+i).checked==true){
        moduleObj = {};
        moduleObj['module'] = props.modules[i].moduleName;
        privileges = "";
        if(document.getElementById('read'+i).checked==true){
          privileges+='read,';
        }
        if(document.getElementById('create'+i).checked==true){
          privileges+='create,';
        }
        if(document.getElementById('update'+i).checked==true){
          privileges+='update,';
        }
        if(document.getElementById('delete'+i).checked==true){
          privileges+='delete,';
        }
        if(document.getElementById('viewall'+i).checked==true){
          privileges+='viewall,';
        }
        if(document.getElementById('modifyall'+i).checked==true){
          privileges+='modifyall,';
        }
        if(document.getElementById('download'+i).checked==true){
          privileges+='download,';
        }
        if(privileges && privileges.length>0){
          privileges = privileges.substring(0,privileges.length-1);
          moduleObj['privileges'] = privileges;
        }
        selectedModuleArr.push(moduleObj);
      }

    }
    setPrivileges(JSON.stringify(selectedModuleArr));

  }


  return (
    <>
      <Dialog fullScreen style={{margin:20}} maxWidth="md" onClose={handleClose} aria-labelledby="customized-dialog-title" open={open}>
        <DialogTitle style={{marginBottom:'-30px'}} onClose={handleClose}></DialogTitle>
          <DialogContent style={{height:'80vh'}}>
            <Grid item   md={12} xs={12} className="test-instructions" >
                  <div className="btmbdrgry"><h3>{(props.dataObj && props.dataObj.autoId>0)?<>Edit</>:<>New</>} Role</h3></div>
                  <p>
                    {/* {privileges} */}
                      <table style={{backgroundColor:'#000000',width:'100%' }} cellSpacing="1" cellPadding="3" >
                        <tr style={{backgroundColor:'#FFFFFF'}} >
                            <td>Role Name</td>
                            <td style={{textAlign:'center'}} >
                            <TextField onChange={event => setRoleName(event.target.value)} value={roleName} sx={{width:'99%',fontSize: 10}} variant="standard" />
                            </td>                            
                        </tr>
                        <tr style={{backgroundColor:'#FFFFFF'}} >
                            <td>Description</td>
                            <td style={{textAlign:'center'}} >
                            <TextField onChange={event => setDescription(event.target.value)} value={description} sx={{width:'99%',fontSize: 10}} variant="standard" />
                            </td>                            
                        </tr>
                        <tr style={{backgroundColor:'#FFFFFF'}} >
                          <td colSpan={2}>
                          <b>Privileges</b><br/> 

                            <table style={{backgroundColor:'#000000',width:'100%',minWidth:600 }} cellSpacing="1" cellPadding="3" >
                            <tr style={{backgroundColor:'#FFFFFF'}} >
                                <td style={{minWidth:180}}>
                                  <input id="modules" onClick={()=>{userRole()}} type="checkbox"  />
                                  Modules
                                </td>
                                <td style={{textAlign:'center',width:100,verticalAlign:'top'}} >
                                  <input id="readall" onClick={()=>{checkAllList('readall','read')}}  type="checkbox"  />
                                  Read
                                </td>
                                <td style={{textAlign:'center',width:100,verticalAlign:'top'}} >
                                  <input id="createall" onClick={()=>{checkAllList('createall','create')}}  type="checkbox"  />
                                  Create
                                </td>
                                <td style={{textAlign:'center',width:100,verticalAlign:'top'}} >
                                  <input id="updateall" onClick={()=>{checkAllList('updateall','update')}}  type="checkbox"  />
                                  Update<br/>if Assignee
                                </td>
                                <td style={{textAlign:'center',width:100,verticalAlign:'top'}} >
                                  <input id="deleteall" onClick={()=>{checkAllList('deleteall','delete')}}  type="checkbox"  />
                                  Delete
                                </td>                            
                                <td style={{textAlign:'center',width:100,verticalAlign:'top'}} >
                                  <input id="viewallall" onClick={()=>{checkAllList('viewallall','viewall')}}  type="checkbox"  />
                                  View All
                                </td>                            
                                <td style={{textAlign:'center',width:100,verticalAlign:'top'}} >
                                  <input id="modifyallall" onClick={()=>{checkAllList('modifyallall','modifyall')}}  type="checkbox"  />
                                  Modify All
                                </td>
                                <td style={{textAlign:'center',width:100,verticalAlign:'top'}} >
                                  <input id="downloadall" onClick={()=>{checkAllList('downloadall','download')}}  type="checkbox"  />
                                  Download
                                </td>
                            </tr>
                            {props.modules?props.modules.map((myRow,mykey)=>(
                            <tr key={'k'+mykey} style={{backgroundColor:'#FFFFFF'}} >
                                <td>
                                  <input id={"module"+mykey} onClick={()=>{moduleUserRole(mykey)}} type="checkbox" />
                                  {myRow.moduleName.replaceAll("_"," ")}
                                </td>
                                <td style={{textAlign:'center',width:100}} >
                                  <input id={"read"+mykey} onClick={()=>{privilegeOne(mykey)}} type="checkbox" />
                                </td>
                                <td style={{textAlign:'center',width:100}} >
                                  <input id={"create"+mykey} onClick={()=>{privilegeOne(mykey)}} type="checkbox" />
                                </td>
                                <td style={{textAlign:'center',width:100}} >
                                  <input id={"update"+mykey} onClick={()=>{privilegeOne(mykey)}} type="checkbox" />
                                </td>
                                <td style={{textAlign:'center',width:100}} >
                                  <input id={"delete"+mykey} onClick={()=>{privilegeOne(mykey)}} type="checkbox" />
                                </td>
                                <td style={{textAlign:'center',width:100}} >
                                  <input id={"viewall"+mykey} onClick={()=>{privilegeOne(mykey)}} type="checkbox" />
                                </td>
                                <td style={{textAlign:'center',width:100}} >
                                  <input id={"modifyall"+mykey} onClick={()=>{privilegeOne(mykey)}} type="checkbox" />
                                </td>
                                <td style={{textAlign:'center',width:100}} >
                                  <input id={"download"+mykey} onClick={()=>{privilegeOne(mykey)}} type="checkbox" />
                                </td>                            
                            </tr>
                            )):null}

                            </table>
                              
                          </td>
                        </tr>
                                              
                      </table>

                      <Box mt={2}>
                          <Button onClick={() => {handleClose()}} style={{marginRight:12}} size="small" variant="outlined" >Cancel</Button>
					    	          <Button onClick={() => {saveData()}} size="small" variant="contained" style={{backgroundColor:'#008000',color:'#FFF',marginRight:10}} >Save</Button>
								      </Box>

                  </p>
            </Grid>
          </DialogContent>
      </Dialog>
      
        <Stack spacing={2} sx={{ width: '100%' }}>
					<Snackbar open={showAlert} autoHideDuration={6000} onClose={hideAlert} anchorOrigin={{vertical,horizontal}}  >
						<Alert onClose={hideAlert} variant="filled" severity={severityAlert} sx={{ width: '100%' }}>
							{alertMessage}
						</Alert>
					</Snackbar>
				</Stack>

    </>
  );

});

export default CustomizedDialogs;